import {
  Shield, Flame, Zap, FileText, FileSignature, FileCheck,
  Droplet, Plug, Tag,
} from 'lucide-react';
import { DOC_TYPES as DOC_TYPE_REGISTRY } from '../../lib/docTypes';

// Map iconName strings from the registry to actual lucide-react components.
export const ICONS = { Shield, Flame, Zap, FileText, FileSignature, FileCheck, Droplet, Plug, Tag };
export const iconFor = (iconName) => ICONS[iconName] || FileText;

// Backward-compatibility: build the legacy DEFAULT_DOCUMENT_TYPES shape so existing
// references (each item must have `.icon`) keep working. This is derived from
// the central registry in /app/frontend/src/lib/docTypes.js.
export const DEFAULT_DOCUMENT_TYPES = DOC_TYPE_REGISTRY.map(t => ({
  value: t.value,
  label: t.label,
  icon: iconFor(t.iconName),
  category: t.category,
  renewal: t.renewal,
  hmoOnly: !!t.hmoOnly,
}));

export const getDocumentIcon = (type) => {
  const docType = DEFAULT_DOCUMENT_TYPES.find(t => t.value === type);
  return docType ? docType.icon : FileText;
};

export const getDocumentLabel = (type) => {
  const docType = DEFAULT_DOCUMENT_TYPES.find(t => t.value === type);
  return docType ? docType.label : type.replace(/_/g, ' ');
};

export const calculateDaysUntilExpiry = (expiryDateStr) => {
  if (!expiryDateStr) return null;
  try {
    const expiryDate = new Date(expiryDateStr);
    if (isNaN(expiryDate.getTime())) return null;
    const now = new Date();
    const diffTime = expiryDate - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  } catch {
    return null;
  }
};

export const getDocumentStatus = (expiryDate) => {
  const days = calculateDaysUntilExpiry(expiryDate);
  if (days === null) return 'normal';
  if (days < 15) return 'urgent';
  if (days < 30) return 'warning';
  return 'normal';
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '—';
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
